import validate from 'validate.js';

const constraints = {
    title: {
	presence: { 
	    message: 'napiši naslov'
	}
    },
    description: {
	presence: { 
	    message: 'napiši besedilo'
	}
    },
    section: {
	presence: { 
	    message: 'izberi kam spada'
	}
    }
}

const PageValidator = ( fields ) => {
    return validate(fields, constraints, {fullMessages: false}) || {};
}

export default PageValidator ;



// WEBPACK FOOTER //
// ./src/validators/PageValidator.js